<div>
<div class="flex flex-col" *ngIf="currentTaxForm">
  <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
    <mat-label>Compare Options </mat-label>
    <input matInput placeholder="Input" style="display: none"
           particleAnalytics
           analyticsCategory= "choice-filter-modal-item-editor"
           analyticsAction= "entity-scope-input">
  <div *ngIf="currentTaxForm.pairedForm">
    <mat-radio-group [(ngModel)]="selectedRadioOption" (ngModelChange)="onSelectionChange($event)">
      <mat-radio-button value="EnglishTranslated" [disabled]="!currentTaxForm.pairedForm" class="m-b-12">
        <div class="flex flex-col"  >
          <span>
            Compare between the English translation and the original form.
          </span>
          <div class="hint flex flex-col">
            <div class="flex flex-row">
              <label class="m-b-5">Name: &nbsp;</label>
            {{currentTaxForm.pairedForm?.name}}
            </div>
            <div class="flex flex-row">
               <label class="m-b-5">Language:&nbsp;</label>
              {{currentTaxForm.pairedForm?.language}}
              </div>
          </div>
        </div>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div *ngIf="!currentTaxForm.pairedForm">
    <mat-radio-group [(ngModel)]="selectedRadioOption" (ngModelChange)="onSelectionChange($event)">
      <mat-radio-button value="EnglishTranslated" [disabled]="!currentTaxForm.pairedForm" class="m-b-12">
        <div class="flex flex-col"  >
          <span>Compare between the English translation and the original form.</span>
          <span class="hint">
          No English translation available for this form.
        </span>
        </div>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div>
    <mat-radio-group [(ngModel)]="selectedRadioOption" (ngModelChange)="onSelectionChange($event)">
      <mat-radio-button value="UserFormOne" class="m-b-12">Compare your document
      </mat-radio-button>
    </mat-radio-group>
  </div>
  </mat-form-field>
  <div *ngIf="selectedRadioOption === 'UserFormOne'">
    <div class="w-p-100">
      <particle-file-selector
        [(file)]="fileToUpload"
        [legend]="'Upload your own document to compare with this form (.pdf).'"
        [required]="true"
        [acceptedTypes]="'.pdf'"
        class="flex flex-row" 
        (change)="handleFileInput()">
      </particle-file-selector>
    </div>
    <div *ngIf="!isCheckFileFormat" style="color: red;" class="m-b-10 flex flex-row">
      <label>Invalid File Type(Accepted Format: Pdf).</label><span>*</span>
    </div>
    <div class="m-b-10">
      <mat-checkbox [(ngModel)]="isFileScanned">Treat as scanned
      </mat-checkbox>
    </div>
    <div *ngIf="isFileScanned">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-select placeholder="Select a Language" [(ngModel)]="toLanguage">
          <mat-option
            *ngFor="let language of taxformsSupportiveLanguage"
            [value]="language.code">
            {{ language.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
<!--    <div *ngIf="canBringNewData">
      <mat-checkbox [(ngModel)]="bringNewDataIntoTranslatedForm">
        Create a certified translation of your document.
      </mat-checkbox>
    </div>-->
  </div>
  <div>
    <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
      <mat-label>Storage * </mat-label>
      <input matInput placeholder="Input" style="display: none"
             particleAnalytics
             analyticsCategory= "choice-filter-modal-item-editor"
             analyticsAction= "entity-scope-input">
      <mat-radio-group [(ngModel)]="storageSettings">
        <mat-radio-button [value]="storageOptions.Stored" class="m-b-12">
          <div class="flex flex-col"  >
          <span>
            I want to store these documents in Orbitax
          </span>
            <div class="hint flex flex-col">
              <div class="flex flex-row">
                Your documents will be available to view, manage and share
                with your contacts via the Translation tool at any point.
              </div>
            </div>
          </div>
        </mat-radio-button>
        <mat-radio-button [value]="storageOptions.NonStored" class="m-b-12">
          <div class="flex flex-col"  >
          <span>
            I do not want to store these documents in Orbitax
          </span>
            <div class="hint flex flex-col">
              <div class="flex flex-row">
                Your documents will be available to download for 24 hours
                before being removed permanently from the system.
              </div>
            </div>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </mat-form-field>
  </div>
</div>
</div>
